export default {
  primary: '#1976d2',
  secondary: '#009688',
  success: '#00bcd4',
  warning: '#2962ff',
  info: '#039be5',
  error: '#01579b',
  track: '#0091ea',
};